export const targetings = {
  tr: {
    vitrin: {
      'kategori-test': {
        targeting: {
          etiket: 'sponsorluvitrincontenttest',
        },
      },
      tchibo: {
        targeting: {
          etiket: 'Tchibo İndirim Günleri, tchiboindirimgunleri',
        },
      },
    },
  },
  en: {},
  ru: {},
};
